import styled from 'styled-components';
import { ReactComponent as DeliveryTruckIcon } from "../../img/entrega-gratis.svg";
import { ReactComponent as Close } from  '../../img/CloseCircle.svg';

type BannerProps = {
    color?: string
    colorInverso?: string
  };



const sizes = {
mobileS: '320px',
mobileM: '375px',
mobileL: '425px',
tablet: '768px',
laptop: '1024px',
laptopL: '1440px',
desktop: '2560px',
};

export const devices = {
mobileS: `(min-width: ${sizes.mobileS})`,
mobileM: `(min-width: ${sizes.mobileM})`,
mobileL: `(min-width: ${sizes.mobileL})`,
tablet: `(min-width: ${sizes.tablet})`,
laptop: `(min-width: ${sizes.laptop})`,
laptopL: `(min-width: ${sizes.laptopL})`,
desktop: `(min-width: ${sizes.desktop})`,
};

const StyledBanner = styled.div<BannerProps>`
    width: 100%;
    background-color: ${props => props.color};

    -webkit-animation: bgcolorchange 4s infinite; 
    animation: 4s infinite bgcolorchange;
    @keyframes bgcolorchange {
        0%, 49% {
            background-color: ${props => props.color};
            color: #FFFFFF;
            & path {
                fill: #FFFFFF;
            }
        }
        50%, 100% {
            background-color: white;
            color: ${props => props.color};
            & path {
                fill: ${props => props.color};
            }
        }
    }
    @-webkit-keyframes bgcolorchange {
        0%, 49% {
            background-color: ${props => props.color};
            color: #FFFFFF;
            & path {
                fill: #FFFFFF;
            }
        }
        50%, 100% {
            background-color: white;
            color: ${props => props.color};
            & path {
                fill: ${props => props.color};
            }
        }
    }
 
`

const StyledContentContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr repeat(3, auto) 1fr;
    grid-column-gap: 5px;
    justify-items: center;
    align-items: center;

`

const StyledImg = styled.div`
    grid-column-start: 2;
    
`

const StyledImgTwo = styled.div`
    @media ${devices.mobileS} {
        visibility: hidden;
    }

    @media ${devices.mobileM} {
        visibility: visible;
    }
`

const StyledCustomIcon = styled(DeliveryTruckIcon) <BannerProps>`
    & path {
        -webkit-animation: fillchange 4s infinite; 
        animation: 4s infinite fillchange;
        @keyframes fillchange {
            0%, 49% {
                fill: #FFFFFF;
            }
            50%, 100% {
                fill: ${props => props.color};
            }
        }
        @-webkit-keyframes fillchange {
            0%, 49% {
                fill: #FFFFFF;
            }
            50%, 100% {
                fill: ${props => props.color};
            }
        }
    }
`

const StyledBannerFonts = styled.span<BannerProps>`
   @media ${devices.mobileS} {
        display: block;
        justify-content: center;
        align-items: center;
        padding: 0.5rem;
    }

    @media ${devices.tablet} {
        padding: 0.6rem 6rem;
        display: flex;
    }

`

const StyledBannerStrongFont = styled.strong`
    padding-right: 2rem;
    @media ${devices.mobileS} {
        display: block;
        justify-content: center;
        padding-left: 2rem;
    }
`

const StyledCloseContainer = styled.div`


    @media ${devices.mobileS} {
        font-weight: strong;
        font-size: 1.5rem;
        position: absolute;
        right: 1rem;

    }

    @media ${devices.tablet} {
        font-weight: strong;
        font-size: 1.5rem;
        position: absolute;
        right: 1rem;
        top: 3.7rem;

    }

    @media ${devices.laptop} {
        font-weight: strong;
        font-size: 1.5rem;
        position: absolute;
        right: 1rem;
        top: 8.5rem;

    }
    
`

const StyledClose =  styled(Close)<BannerProps>`

    cursor: pointer;

    & path {
        -webkit-animation: fillchange 4s infinite; 
        animation: 4s infinite fillchange;
        @keyframes fillchange {
            0%, 49% {
                fill: #FFFFFF;
            }
            50%, 100% {
                fill: ${props => props.color};
            }
        }
        @-webkit-keyframes fillchange {
            0%, 49% {
                fill: #FFFFFF;
            }
            50%, 100% {
                fill: ${props => props.color};
            }
        }
    }
`



export {StyledBanner, StyledContentContainer, StyledImg, StyledImgTwo, StyledCustomIcon, StyledBannerFonts, StyledBannerStrongFont, StyledCloseContainer, StyledClose}